// Features/Ingredient-Slide/Debounce.ts
function debounce(callback, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(args), timeout);
  };
}

// Features/Ingredient-Slide/Component.ts
var Selector_Description = `.Ingredient-Description .metafield-rich_text_field`;
var Selector_Slider = `slider-component`;

class Component extends HTMLElement {
  parts;
  constructor() {
    super();
    this.parts = {
      description: this.querySelector(Selector_Description),
      slider: this.closest(Selector_Slider)
    };
    const index = this.dataset.index;
    const expand = this.parentElement.querySelector(`input[ data-index = '${index}'`);
    expand.addEventListener("click", () => {
      if (expand.checked)
        return;
      setTimeout(() => {
        const relative = this.parentElement.parentElement;
        const y = relative.offsetTop - (window.innerHeight - relative.scrollHeight) / 2;
        window.scrollTo({
          behavior: "smooth",
          top: y
        });
      }, 300);
    });
    this.parts.slider.addEventListener("Slider:Change", (event) => {
      if (!expand.checked)
        return;
      event.preventDefault();
      setTimeout(() => {
        this.parts.slider.scroll();
      }, 200);
      expand.checked = false;
    });
    this.updateHeight();
    window.addEventListener("resize", debounce(this.updateHeight.bind(this), 150));
  }
  updateHeight() {
    this.style.setProperty("---Height", null);
    setTimeout(() => {
      const height = this.parts.description.scrollHeight;
      this.style.setProperty("---Height", `${height}px`);
    }, 0);
  }
}
// Features/Ingredient-Slide/mod.ts
customElements.define("ingredient-slide", Component);
export {
  Component as IngredientSlide
};
